import { useSearchParams } from "react-router-dom";
import { getValidBigInt } from "../util/bigInt";

export default function useUidParam() {
  const [searchParams] = useSearchParams();
  const uidParam = searchParams.get('uid');
  return getValidBigInt(uidParam);
}